import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	customTemplateProjectBannerMessage: {
		id: 'jira-horizontal-nav.custom-template-project-banner-message',
		defaultMessage:
			'This project is saved as a custom template. Project settings changes will apply to the template.',
		description:
			'Description shown to use to inform that the current project is being used as a custom template',
	},
});
